export const DESCRIPTION = 'EPVS Calculations';
